import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as Excel from "exceljs";
/*import './App.css';*/
/*import { Multiselect } from 'multiselect-react-dropdown';
import { Dropdown } from 'semantic-ui-react'*/
import { Multiselect } from "multiselect-react-dropdown";

import MultiSelectReact from "multi-select-react";
/*import Multiselect from 'multiselect-dropdown-react';
 */ import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import MySelect from "../../../../shared/components/form/MySelect";
import LoadingOverlay from 'react-loading-overlay';
import "./styles.css";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
var url = window.location.hostname;
var port = window.location.port;
let options = [];
const optionsUser = [];
var bin_array = [];
var rfqCheckedAll = {};
var zone_arr = [];
var aisles_arr = [];
var racks_arr = [];
var racks_aisle = [];

var options2 = [];

const options1 = [];



const exportToCSV = (csvData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.onSubmitCycleCount = this.onSubmitCycleCount.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.result = this.result.bind(this);
    this.onChangeVal3 = this.onChangeVal3.bind(this);
    this.onChangeVal = this.onChangeVal.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.processData = this.processData.bind(this);
    this.processData1 = this.processData1.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.messagetoggle = this.messagetoggle.bind(this);
    this.toggleReports = this.toggleReports.bind(this);
    this.messageToggleCycle = this.messageToggleCycle.bind(this);
    this.cancelMessageModal = this.cancelMessageModal.bind(this);
    this.cancelToggle = this.cancelToggle.bind(this);
    this.cancelMessageModalCycle = this.cancelMessageModalCycle.bind(this);
    this.confirmData = this.confirmData.bind(this);
    this.failedToggle = this.failedToggle.bind(this);
    this.failedToggleCycle = this.failedToggleCycle.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.changeType = this.changeType.bind(this);
    this.onChangeVal1 = this.onChangeVal1.bind(this);
    this.onChangeValStock = this.onChangeValStock.bind(this);
    this.onChangeVal2 = this.onChangeVal2.bind(this);
    this.setStockTake = this.setStockTake.bind(this);
    this.setCycleCount = this.setCycleCount.bind(this);
    this.onSubmitBtn = this.onSubmitBtn.bind(this);
    this.toggleAssignUser = this.toggleAssignUser.bind(this);
    this.failedToggleCancel = this.failedToggleCancel.bind(this);
    this.failedToggleCancelCycle = this.failedToggleCancelCycle.bind(this);
    this.toggleAssignUserCycleCount = this.toggleAssignUserCycleCount.bind(
      this
    );
    this.fetchCycleCountDashboard = this.fetchCycleCountDashboard.bind(this);
    this.onCancelCycleModal = this.onCancelCycleModal.bind(this);
    this.successToggle = this.successToggle.bind(this);
    this.successToggle1 = this.successToggle1.bind(this);
    this.confirmData = this.confirmData.bind(this);
    this.AssignUser = this.AssignUser.bind(this);
    this.downloadSKU = this.downloadSKU.bind(this);
    this.exportToCSV = this.exportToCSV.bind(this);
    this.downloadCompleteStock = this.downloadCompleteStock.bind(this);
    this.downloadExcessStock = this.downloadExcessStock.bind(this);
    this.closeReportModal = this.closeReportModal.bind(this);
    /*this.optionClicked = this.optionClicked.bind(this);
   this.selectedBadgeClicked = this.selectedBadgeClicked.bind(this);*/
    this.multiSelectEl = [];

    this.state = {
      product_header: [
        { "Product Code": "", "MRP": "" },
      ],
      showPassword: false,
      ischeckedbin: false,
      options2: [],
      options1: [],
      loadingGRNData: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      error_list: [],
      upload_error_list: [],
      show_upload_error_list: false,
      zoneData: [],
      cycleCountCancelModal: false,
      toSelectData: [],
      SelectedBins: [],
      genloading: false,
      genloading7: false,
      selectedOptionRadio: "",
      loadBinData: false,
      schemas: [],
      showFetchGRNData: false,
      successModal: false,
      loadingprintbtn: false,
      modalAssignUser: false,
      zoneDataVal: [],
      removeSelectedDate: false,
      modalCancel: false,
      isChecked: false,
      showFailedItem: false,
      showCross: false,
      isCheckedData: {},
      zoneTypeFlag: false,
      FailedItems: [],
      grnNumber: "",
      grnValues: "",
      grnLineValue: "",
      selectedOptions: "",
      failedMessage: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      messageModalCycle: false,
      show_bin_list: false,
      modalReport: false,
      disabledSubmitBtn: false,
      modalfailedCycle: false,
      showDashboardData: true,
      showRack: false,
      showZone: false,
      showProcess: true,
      onSelectProcess: "",
      selected_rack: "",
      selectedOptionType: "",
      showAisle: false,
      showBinTable: true,
      modalfailed: false,
      checkedAll: false,
      rfqCheckedAll: {},
      bin_address_list: [],
      rfqChecked: {},
      postsGRN: [],
      postsProduct: [],
      multiSelect: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsProduct: [],
      ErrorRowData: [],
      binData: [],
      options: [],
      newArrayData: [],
      newArrayData1: [],
      totalScanCount: "",
      selectedUser: {},
      selectedaisle: "",
      showAssignButton: true,
      showPrintButton: false,
      showSubmitBtn: false,
      clearData: false,
      showSelectedBin: false,
      optionSelected: null,
      optionSelected1: null,
      optionSelected2: null,
      isdisableAssignBtn: true,
      isdisableBinAssignBtn: false,
      optionForBinAddressDropdown: [],
      showBinAddressDropdown: false,
      showProductDropdown: false,
      value: "0",
      selectedBinAddress: "",
      all_binaddress: [],
      dropdownInProgress: false,
      containerOnKeyDown: false,
      loading_overlay: false,
    };
  }

  result(params) {
  }

  setStockTake() {
    this.setState({
      selectedOptionRadio: "stockTake",
    });
  }

  onSubmitBtn2 = () => {
    //console.log("selected zone",this.state.selectedZone)
    zone_arr = [];
    this.setState({
      genloading4: true,
      binData: [],
      ischeckedbin: false,
      show_bin_list: false,
      show_error_list: false,
      show_upload_error_list: false,
      selectedaisle: '',
      selected_rack: '',
      zone_arr: [],
      product_code: '',
      mrp: '',
      product_brand: '',
      category: '',
      sub_category: '',
      division: '',
      parent_code: '',
      data: [],
      file: {
        name: null
      }

    })

    //return false;


    if (this.state.selectedOptionValue == 3) {
      this.setState({
        showBinAddressDropdown: false,

        showProductDropdown: true,
        showZone: false,
        onSelectProcess: this.state.onSelectProcessVal,
        isdisableBinAssignBtn: false,
        showSelectedBin: false,
        showBinTable: false,
        SelectedBins: [],
        binData: [],
        genloading4: false
      })
      this.setState({
              file: {}, // Clear file from state
              loading_overlay: false,
            }, () => {
              if (this.fileInput) {
                this.fileInput.value = ""; // Reset file input field
              }
            });
            if (document.getElementById("my_file_input") !== null) {
              document.getElementById("my_file_input").style.color =
                "transparent";
              document.getElementById("picking_label").style.display = "inline-block";
              document.getElementById("picking_label").innerHTML =
                "Select and Upload Picksheet";
                document.getElementById("my_file_input").style.width = "26%";
            $(".upload_error").css('display', 'none');
            $(".upload_success").css('display', 'none');
            }
                }

    if (this.state.selectedOptionValue == 1) {
      this.setState({
        showBinAddressDropdown: true,
        showProductDropdown: false,
        showZone: false,
        onSelectProcess: this.state.onSelectProcessVal,
        isdisableBinAssignBtn: false,
        showSelectedBin: false,
        showBinTable: false,
        SelectedBins: [],
        binData: [],
        genloading4: false
      })
    }

    if (this.state.selectedOptionValue == 2) {
      this.onZoneSelect();
      this.setState({
        showBinAddressDropdown: false,
        showProductDropdown: false,
        showZone: true,
        onSelectProcess: this.state.onSelectProcessVal,
        isdisableBinAssignBtn: false,
        SelectedBins: [],
        binData: [],
        //genloading4: false
      })

    }

    if (this.state.selectedOptionValue == 6) {
      this.setState({
        showZone: true,
        showBinAddressDropdown: false,
        showProductDropdown: false

      });

      const payload = {

        location: this.state.selectedLocation,
        bin_in_use: true,
        zone_type: this.state.selectedZone
      };

      API.post('/cycle_count/binsCycleCount/v1/', { param: payload })
        .then((response) => {
          let newBinData = response.data.map((item) => ({
            ...item,
            isChecked: false,
          }));

          this.setState({
            bin_address_list: newBinData,
            show_bin_list: true,
            genloading4: false
          })
        })
        .catch(function (error) { });
    }

    if (this.state.selectedOptionValue == 4) {
      this.setState({
        showZone: false,
        showBinAddressDropdown: false,
        showProductDropdown: false

      });

      const payload = {

        location: this.state.selectedLocation,
      };

      API.post('/cycle_count/cycleCountRecommendedReport/v1/', { param: payload })
        .then((response) => {
          let newBinData = response.data.map((item) => ({
            ...item,
            isChecked: false,
          }));
          this.setState({
            bin_address_list: newBinData,
            show_bin_list: true,
            genloading4: false
          })
        })
        .catch(function (error) { });
    }


    if (this.state.selectedOptionValue == 5) {
      this.setState({
        showZone: false,
        showBinAddressDropdown: false,
        showProductDropdown: false

      });

      const payload = {

        location: this.state.selectedLocation,
        zone_type: this.state.selectedZone
      };

      API.post('/cycle_count/cycleCountParameters/v1/', { param: payload })
        .then((response) => {
          this.setState({
            newArrayData: response.data.zones,
            genloading: false,
          });
          this.toggleAssignUser();
        })
        .catch(function (error) { });
    }



  }

  exportToCSV(csvData, fileName) {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }

  exportToCSV1 = (csvData, FileName) => {
    try {
      var workbook = new Excel.Workbook();
      var worksheet = workbook.addWorksheet("My Sheet");

      worksheet.addRow({});
      worksheet.addRow([
        "",
        "Product",
        "PKD",
        "MRP",
        "QTY",
        "CBU Code",
        "Product",
        "PKD",
        "MRP",
        "QTY",
        "CBU Code",
        "",
        "Product",
        "PKD",
        "QTY",
        "Product",
        "PKD",
        "QTY",
      ]);

      csvData.map((item) =>
        worksheet.addRow([
          item["Bin Address"],
          item["System Sku Id"],
          item["System PKD"],
          item["System MRP"],
          item["System Qty"],
          item["System CBU"],
          item["Scanned Sku Id"],
          item["Scanned PKD"],
          item["Scanned MRP"],
          item["Scanned Qty"],
          item["Scanned CBU"],
          item["Status"],
          item["Excess Sku Id"],
          item["Excess PKD"],
          item["Excess Qty"],
          item["Short Sku Id"],
          item["Short PKD"],
          item["Short Qty"],
          item["Assigned User"],
        ])
      );

      worksheet.mergeCells("B1:F1");
      worksheet.mergeCells("G1:K1");
      worksheet.mergeCells("M1:O1");
      worksheet.mergeCells("P1:R1");

      worksheet.getCell("A1").value = "Bin Address";
      worksheet.getCell("B1").value = "System";
      worksheet.getCell("G1").value = "Physical/Scanned";
      worksheet.getCell("L1").value = "Status";
      worksheet.getCell("M1").value = "Excess (Physical)";

      worksheet.getCell("P1").value = "Short (Physical)";
      worksheet.getCell("S1").value = "Assigned User";

      // FileSaver.saveAs(worksheet, FileName + " Batch" + fileExtension);

      workbook.xlsx.writeBuffer().then((data) => {
        var blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, FileName + " Batch" + fileExtension);
      });
    } catch (error) {
    }
  };

  closeReportModal() {
    this.setState({ modalReport: false });
  }

  cancelToggle() {
    this.setState((prevState) => ({ modalCancel: !prevState.modalCancel }));
  }

  toggleReports(batchId) {
    this.setState((prevState) => ({
      modalReport: !prevState.modalReport,
      batchIdVal: batchId,
    }));
  }

  onCancelCycleModal(batchId) {
    this.setState({
      batchId: batchId,
    });
    this.setState((prevState) => ({
      cycleCountCancelModal: !prevState.cycleCountCancelModal,
    }));
  }

  downloadSKU() {
    const payload = {
      batch_id: this.state.batchIdVal,

      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/cycleReconReportV2/', { param: payload })
      .then((response) => {
        this.exportToCSV1(
          response.data,
          this.state.batchIdVal + "_SKULevelReport"
        );
      })
      .catch(function (error) { });
  }

  getZoneData = () => {
    API.get('/product/product_master/v1/zone_types/')
      .then((response) => {
        const rawData = response.data.data;

        const transformedData = rawData.map((item) => ({
          label: item.type_desc,
          value: item.zone_type
        }));

        this.setState({
          zoneData: transformedData
        });
      })
      .catch(function (error) {
        console.error("Error fetching zone data:", error);
      });
  }


  getSelectData = () => {


    API.get('/cycle_count/fetch-create-cc-menu')
      .then((response) => {
        console.log('RESPONSE======>',response)
        this.setState({
          toSelectData: response.data.data[0]
        })
      })
      .catch(function (error) { });
  }

  downloadCompleteStock() {
    const payload = {
      batch_id: this.state.batchIdVal,
      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/cycleCompleteStock/v1/', { param: payload })
      .then((response) => {
        this.exportToCSV(
          response.data,
          this.state.batchIdVal + "_completeStockReport"
        );
      })
      .catch(function (error) { });
  }

  downloadExcessStock() {
    const payload = {
      batch_id: this.state.batchIdVal,
      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/cyclePhysicalExcessStock/v1/', { param: payload })
      .then((response) => {
        this.exportToCSV(
          response.data,
          this.state.batchIdVal + "_excessStockReport"
        );
      })
      .catch(function (error) { });
  }

  onCancel(batchId) {
    this.setState({
      loading_overlay: true
    })
    const payload = {
      batch_id: this.state.batchId,
      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/cancelCycleCount/v1/', { param: payload })
      .then((response) => {
        this.setState({
          loading_overlay: false,
          cycleCountCancelModal: false,
        });

        if (response.data.status == true) {
          this.setState({
            cancelReason: response.data.reason,
            modalCancel: true,
          });

          this.fetchCycleCountDashboard();
        } else if (response.data.status == false) {
          this.setState({
            cancelReason: response.data.reason,
            modalCancel: true,
          });

          this.fetchCycleCountDashboard();
        }
      })
      .catch(function (error) { });
  }
  componentDidMount() {
    this.fetchUserList();
    this.getSelectData();
    this.getZoneData();
    //this.fetchCycleCountDashboard();
  }

  AssignUser() {
    this.setState({
      selectedUser: {},
      modalAssignUserCycleCount: true,
      selectedOptions: "",
      newArrayData1: [],
    });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    //console.log(this.state.binData);
    if (this.state.selectedOptionType == 3) {
      var arrayCartData = bin_array.filter(
        (item) => item.isChecked === true
      );
    } else {
      var arrayCartData = this.state.binData.filter(
        (item) => item.isChecked === true
      );
    }

    this.setState({
      newArrayData1: arrayCartData,
    });

    var arr = [];

    for (var i = 0; i < arrayCartData.length; i++) {
      arr.push(arrayCartData[i].id);
    }
    //arr = [4341];

    const payload = {
      bins: arr,
    };

    API.post('/cycle_count/fetchCycleCountScanCount/v1/', { param: payload })
      .then((response) => {
        this.setState({
          totalScanCount: response.data.ScanCount,
        });
      })
      .catch(function (error) { });
  }

  setCycleCount() {
    this.setState({
      selectedOptionRadio: "cycleCount",
    });
  }

  failedToggleCancel() {
    this.setState({
      modalfailed: false,
    });

    window.location.reload();
  }

  failedToggleCancelCycle() {
    this.setState({
      modalfailedCycle: false,
    });

    window.location.reload();
  }

  onBlurBinAddress = (event) => {
    var selected_val = event.target.value;
    if (selected_val == "" || selected_val == undefined) {
      this.setState({
        containerOnKeyDown: false,
      })
    }
  }

  onSelectBinAddress = (selected) => {
    let bin_address_arr = this.state.selectedBinAddress.split(",");

    var binData = [...this.state.binData];

    for (let i = 0; i < selected.length; i++) {
      bin_address_arr.push(selected[i]["label"]);
      binData.push({
        id: selected[i].value,
        isChecked: true,
        zone__zone_code: selected[i].zone__zone_code,
        zone_id: selected[i].zone_id,
        bin_address: selected[i].label,
      });
    }

    this.setState(
      {
        //selectedBinAddress: selected_value,
        all_binaddress: bin_address_arr,
        binData: binData,
        SelectedBins: binData,
        isdisableAssignBtn: false,
        showSelectedBin: true,
        showCross: true,
        isdisableBinAssignBtn: true,
      },
      () => {
        for (let i = 0; i < bin_address_arr.length; i++) {
          if (
            this.state.binData.some(
              (item) => item.bin_address === bin_address_arr[i]
            )
          ) {
          } else {
            bin_address_arr.splice(i, 1);
          }
        }
        if (bin_address_arr.length == 0) {
          this.setState({
            isdisableAssignBtn: true,
            containerOnKeyDown: false,
          });
        }
      }
    );
  };
  onBinAddressKeyup = (event) => {
    this.setState({
      showZone: false,
      dropdownInProgress: true,
    });
    var selectedval = { ...this.state.selectedBinAddress };
    selectedval = event.target.value;
    this.setState({
      selectedBinAddress: selectedval,
    });

    if (selectedval == "" || selectedval == undefined) {
      this.setState({
        containerOnKeyDown: false,
      })
      return false;
    }
    const payload = {
      location: this.state.selectedLocation,
      bin_address: event.target.value,
    };

    API.post('/inventory/fetchBins/v1/', { param: payload })
      .then((response) => {
        //console.log(response);
        //optionForBinAddressDropdown
        let options = [];
        for (var i = 0; i < response.data.length; i++) {
          var orderData = {};
          orderData["label"] = response.data[i].bin_address;
          orderData["value"] = response.data[i].id;
          orderData["zone_id"] = response.data[i].zone_id;
          orderData["zone__zone_code"] = response.data[i].zone__zone_code;
          //orderData["id"] = response.data.zones[i].id;

          options.push(orderData);
        }
        if (selectedval == "" || selectedval == undefined) {
          this.setState({
            optionForBinAddressDropdown: options,
            dropdownInProgress: false,
            containerOnKeyDown: false,
          })
          return false;
        } else {
          this.setState({
            optionForBinAddressDropdown: options,
            dropdownInProgress: false,
            containerOnKeyDown: true,
          });
        }
        if (response.daa.length == 0) {
          this.setState({
            containerOnKeyDown: false,
          });
        }
      })
      .catch(function (error) { });
  };

  checkedSingle(index, bin, id) {
    //console.log(this.state.binData);
    let newData = this.state.bin_address_list;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      bin_array.push(newData[index])

    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      bin_array = bin_array.filter((item) => item.id !== id);

    }

    this.setState({
      genloading: !this.state.genloading,
      bin_address_list: newData,
      isdisableAssignBtn: false,
      showSelectedBin: true,
      binData: bin_array,
      showCross: false

    });
  }

  onSubmitBtn() {
    this.setState({
      ischeckedbin: false,
      show_bin_list: false,
      show_error_list: false,
      show_upload_error_list: false,
      file: {
        name: null
      }

    })
     this.setState({
              file: {}, // Clear file from state
              loading_overlay: false,
            }, () => {
              if (this.fileInput) {
                this.fileInput.value = ""; // Reset file input field
              }
            });
            if (document.getElementById("my_file_input") !== null) {
              document.getElementById("my_file_input").style.color =
                "transparent";
              document.getElementById("picking_label").style.display = "inline-block";
              document.getElementById("picking_label").innerHTML =
                "Select and Upload Picksheet";
                document.getElementById("my_file_input").style.width = "26%";
            $(".upload_error").css('display', 'none');
            $(".upload_success").css('display', 'none');
            }
                
    const payload = {
      ...(this.state.product_code ? { sku7: this.state.product_code } : {}),
      ...(this.state.mrp ? { mrp: this.state.mrp } : {}),
      ...(this.state.division ? { division: this.state.division } : {}),
      ...(this.state.category ? { category: this.state.category } : {}),
      ...(this.state.sub_category ? { sub_category: this.state.sub_category } : {}),
      ...(this.state.parent_code ? { base_pack_code: this.state.parent_code } : {}),
      ...(this.state.product_brand ? { brand: this.state.product_brand } : {}),



      /* division: this.state.division,
       category: this.state.category,
       sub_category: this.state.sub_category,
       base_pack_code: this.state.parent_code,*/
      cc_by_product: true,
      zone_type: this.state.selectedZone
    }

    API.post('/cycle_count/binsCycleCount/v1/', { param: payload })
      .then((response) => {
       
        if (response.data.success == true) {
         
          let newBinData = response.data.data.map((item) => ({
            ...item,
            isChecked: false,
          }));
          this.setState({
            bin_address_list: newBinData,
            show_bin_list: true,
            show_error_list: false,
          })
        } else {
          
          this.setState({
            errorListMessage: response.data.message,
            error_list: response.data.data,
            show_bin_list: false,
            show_error_list: true
          })

        }

      })
      .catch(function (error) { });
  }



  onSubmitCycleCount() {
    this.setState({
      loadBinData: true,
    });

    /*this.toggleAssignUserCycleCount();*/

    const payload = {
      location: this.state.selectedLocation,
      rack: racks_arr,
      // aisle: aisles_arr,
      aisle: [this.state.selectedaisle],
      racks_aisle: [this.state.selected_rack],
      zone: zone_arr,
      zone_type: this.state.selectedZone
      // rack_aisle: racks_aisle,
    };

    API.post('/cycle_count/binsCycleCount/v1/', { param: payload })
      .then((response) => {
        this.setState({
          showBinTable: true,
          binData: response.data.data,
          loadBinData: false,
        });

        let newBinData = response.data.data.map((item) => ({
          ...item,
          isChecked: false,
        }));

        /*this.setState({
          binData: newBinData,
        });*/

        this.setState({
          bin_address_list: newBinData,
          show_bin_list: true
        })
      })
      .catch(function (error) { });
  }

  changeType = (selectedOption) => {
    if (selectedOption.value === "stock_pick") {
      this.setState({
        showBinTable: true,
        showZone: false,
        showAisle: false,
        showRack: false,
      });
    } else if (selectedOption.value === "cycle_count") {
      this.setState({
        showBinTable: false,
        showZone: true,
      });
    }
  };

  fetchUserList() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post('/auth/users/getusers', { param: payload })
      .then((response) => {
        for (var i = 0; i < response.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          orderData["label"] = response.data[i].userName;
          orderData["value"] = response.data[i].userId;

          optionsUser.push(orderData);
        }

        /* console.log(this.state.options);*/
      })
      .catch(function (error) { });
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }
    else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }



  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  messagetoggle() {
    this.setState({
      messageModal: true,
    });
  }

  messageToggleCycle() {
    this.setState({
      messageModalCycle: true,
    });
  }

  toggleAssignUser() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUser: !prevState.modalAssignUser,
    }));
  }

  successToggle() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ successModal: !prevState.successModal }));

    // window.location.href = "/maintenance/cycleCount/assignUser";
  }
  successToggle1() {
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    window.location.href = "/maintenance/cycleCount/assignUser";
  }

  failedToggle() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ modalfailed: !prevState.modalfailed }));
  }

  failedToggleCycle() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalfailedCycle: !prevState.modalfailedCycle,
    }));
  }

  toggleAssignUserCycleCount() {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUserCycleCount: !prevState.modalAssignUserCycleCount,
    }));
  }

  
cancelMessageModalCycle() {
  var arr = [];

  // Building cycle_data
  _.map(this.state.selectedUser, (item, key) => {
    var bin_arr = [];
    var orderData = {};

    orderData["zone"] = parseInt(key);
    orderData["users"] = item[0];

    item[1].map((item1) => {
      bin_arr.push(item1.id);
    });

    orderData["bins"] = bin_arr;

    arr.push(this.removeEmptyKeys(orderData)); // clean each cycle_data object
  });

  let productArr = [];

  // Building product_details
  if (this.state.data.length > 0) {
    for (var i = 0; i < this.state.data.length; i++) {
      var orderData = {};

      const productCode = this.state.data[i]["Product Code"];
      const mrp = this.state.data[i]["MRP"];

      if (productCode !== undefined && productCode !== null && productCode !== "") {
        orderData["sku7_code"] = productCode;
      }

      if (mrp !== undefined && mrp !== null && mrp !== "") {
        orderData["mrp"] = mrp;
      }

      const cleanedOrderData = this.removeEmptyKeys(orderData);

      if (Object.keys(cleanedOrderData).length > 0) {
        productArr.push(cleanedOrderData);
      }
    }
  } else {
    var orderData = {};

    if (this.state.product_code) {
      orderData["sku7_code"] = this.state.product_code;
    }

    if (this.state.mrp) {
      orderData["mrp"] = this.state.mrp;
    }

    const cleanedSingleData = this.removeEmptyKeys(orderData);

    if (Object.keys(cleanedSingleData).length > 0) {
      productArr.push(cleanedSingleData);
    }
  }

  // Build the payload
  const payload = {
    create: true,
    location: this.state.selectedLocation,
    req_type: "cc",
    cycle_data: arr,
    zone_type: this.state.selectedZone,
    ...(productArr.length > 0 ? { product_details: productArr } : {}) // only include if not empty
  };

  const cleanedPayload = this.removeEmptyKeys(payload); // Clean top-level

  console.log("Cleaned Payload:", cleanedPayload);

  // Send API request
  API.post('/cycle_count/createCycleCount/v1/', { param: cleanedPayload })
    .then((response) => {
      this.setState({
        messageModalCycle: false,
        success_message: "Successfully Updated"
      });
      this.successToggle();
    })
    .catch(function (error) {
      console.error("API error:", error);
    });
}

  cancelMessageModal() {
    this.setState({
      loadingprintbtn: true,
    });

    var arr = [];


    _.map(this.state.selectedUser, (item, key) => {
      var orderData = {};
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];

      arr.push(orderData);
    });
      let productArr = [];

      // Building product_details
      if (this.state.data.length > 0) {
        for (var i = 0; i < this.state.data.length; i++) {
          var orderData = {};

          const productCode = this.state.data[i]["Product Code"];
          const mrp = this.state.data[i]["MRP"];

          if (productCode !== undefined && productCode !== null && productCode !== "") {
            orderData["sku7_code"] = productCode;
          }

          if (mrp !== undefined && mrp !== null && mrp !== "") {
            orderData["mrp"] = mrp;
          }

          const cleanedOrderData = this.removeEmptyKeys(orderData);

          if (Object.keys(cleanedOrderData).length > 0) {
            productArr.push(cleanedOrderData);
          }
        }
      } else {
        var orderData = {};

        if (this.state.product_code) {
          orderData["sku7_code"] = this.state.product_code;
        }

        if (this.state.mrp) {
          orderData["mrp"] = this.state.mrp;
        }

        const cleanedSingleData = this.removeEmptyKeys(orderData);

        if (Object.keys(cleanedSingleData).length > 0) {
          productArr.push(cleanedSingleData);
        }
      }
    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "st",
      cycle_data: arr,
      zone_type: this.state.selectedZone,
       ...(productArr.length > 0 ? { product_details: productArr } : {})
    };
     const cleanedPayload = this.removeEmptyKeys(payload); // clean top-level

    console.log("Cleaned Payload:", cleanedPayload);

    API.post('/cycle_count/createCycleCount/v1/', { param: cleanedPayload })
      .then((response) => {
        if (response.data.status_code === 200) {
          this.setState({
            messageModal: false,
            success_message: "Successfully Updated"
          });
          this.successToggle();
        }
      })
      .catch(function (error) { });
  }

  removeEmptyKeys(obj) {
    const cleaned = {};
    Object.keys(obj).forEach(key => {
      if (
        obj[key] !== undefined &&
        obj[key] !== null &&
        obj[key] !== ""
      ) {
        cleaned[key] = obj[key];
      }
    });
    return cleaned;
  }

  confirmData() {
    this.setState({
      messageModal: false,
    });

    this.setState({
      loadingprintbtn: true,
    });

    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var orderData = {};
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];

      arr.push(orderData);
    });
    let productArr = [];

      // Building product_details
      if (this.state.data.length > 0) {
        for (var i = 0; i < this.state.data.length; i++) {
          var orderData = {};

          const productCode = this.state.data[i]["Product Code"];
          const mrp = this.state.data[i]["MRP"];

          if (productCode !== undefined && productCode !== null && productCode !== "") {
            orderData["sku7_code"] = productCode;
          }

          if (mrp !== undefined && mrp !== null && mrp !== "") {
            orderData["mrp"] = mrp;
          }

          const cleanedOrderData = this.removeEmptyKeys(orderData);

          if (Object.keys(cleanedOrderData).length > 0) {
            productArr.push(cleanedOrderData);
          }
        }
      } else {
        var orderData = {};

        if (this.state.product_code) {
          orderData["sku7_code"] = this.state.product_code;
        }

        if (this.state.mrp) {
          orderData["mrp"] = this.state.mrp;
        }

        const cleanedSingleData = this.removeEmptyKeys(orderData);

        if (Object.keys(cleanedSingleData).length > 0) {
          productArr.push(cleanedSingleData);
        }
      }
    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "st",
      cycle_data: arr,
      zone_type: this.state.selectedZone,
      ...(productArr.length > 0 ? { product_details: productArr } : {})
    };
     const cleanedPayload = this.removeEmptyKeys(payload); // clean top-level

    console.log("Cleaned Payload:", cleanedPayload);

    API.post('/cycle_count/createCycleCount/v1/', { param: cleanedPayload })
      .then((response) => {
        if (response.data.status_code === 200) {
          this.setState({
            messageModal: false,
            success_message: "Successfully Updated"
          });
          this.successToggle();
        }
      })
      .catch(function (error) { });
  }

  processData() {
    this.setState({
      loadingprintbtn: true,
    });
   
    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var orderData = {};
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];

      arr.push(orderData);
    });

    let productArr=[];

    if(this.state.data.length > 0){

        for (var i = 0; i < this.state.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
          orderData["zoneName"] = this.state.data[i]["ZoneName"];
          orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

          if (this.state.data[i]["Product Code"] == undefined || this.state.data[i]["Product Code"] == null) {
            orderData["sku7_code"] = "";
          } else {
            orderData["sku7_code"] = this.state.data[i]["Product Code"];
          }

          if (this.state.data[i]["MRP"] == undefined || this.state.data[i]["MRP"] == null) {
            orderData["mrp"] = "";
          } else {
            orderData["mrp"] = this.state.data[i]["MRP"];
          }

          productArr.push(orderData);
        }
    }else{
      var orderData = {};
      orderData["sku7_code"] = this.state.product_code;
      orderData["mrp"] = this.state.mrp;
      productArr.push(orderData);
    }

    console.log("ARRAY", arr)

    const payload = {
      create: false,
      location: this.state.selectedLocation,
      req_type: "st",
      cycle_data: arr,
      zone_type: this.state.selectedZone,
       ...(productArr.length > 0 ? { product_details: productArr } : {})
    };
    const cleanedPayload = this.removeEmptyKeys(payload); // clean top-level

    console.log("Cleaned Payload:", cleanedPayload);


    API.post('/cycle_count/createCycleCount/v1/', { param: cleanedPayload })
      .then((response) => {
        if (response.data.status_code === 201) {
          this.setState({
            failedMessage: response.data.reason,
          });
          this.toggleAssignUser();
          this.failedToggle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length === 0
        ) {
          this.setState({
            alertMessage: "Are you sure you want to confirm ? ",
          });
          this.toggleAssignUser();
          this.messagetoggle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length > 0
        ) {
          this.setState({
            failedMessage: response.data.reason,
            showFailedItem: true,
            FailedItems: response.data.failed,
          });
          this.toggleAssignUser();
          this.failedToggle();
        }
      })
      .catch(function (error) { });
  }

  processData1() {
    this.setState({
      loadingprintbtn: true,
    });

    var arr = [];
   

    _.map(this.state.selectedUser, (item, key) => {
      var bin_arr = [];
      var orderData = {};
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];
      /*item[1].map(( item1 , index ) => (
        console.log(item1)
        bin_arr.push(item1.bin_address.push)


      ))*/

      item[1].map((item1) => {
        bin_arr.push(item1.id);
      });

      orderData["bins"] = bin_arr;

      arr.push(orderData);
    });

    let productArr = [];
    if(this.state.data.length > 0){
     

        for (var i = 0; i < this.state.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
          orderData["zoneName"] = this.state.data[i]["ZoneName"];
          orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

          if (this.state.data[i]["Product Code"] == undefined || this.state.data[i]["Product Code"] == null) {
            orderData["sku7_code"] = "";
          } else {
            orderData["sku7_code"] = this.state.data[i]["Product Code"];
          }

          if (this.state.data[i]["MRP"] == undefined || this.state.data[i]["MRP"] == null) {
            orderData["mrp"] = "";
          } else {
            orderData["mrp"] = this.state.data[i]["MRP"];
          }

          productArr.push(orderData);
        }
    }else{
      var orderData = {};
      orderData["sku7_code"] = this.state.product_code;
      orderData["mrp"] = this.state.mrp;
      productArr.push(orderData);
    }


    const payload = {
      create: false,
      location: this.state.selectedLocation,
      req_type: "cc",
      cycle_data: arr,
      zone_type: this.state.selectedZone,
       ...(productArr.length > 0 ? { product_details: productArr } : {})
    };
    const cleanedPayload = this.removeEmptyKeys(payload); // clean top-level

    console.log("Cleaned Payload:", cleanedPayload);

    API.post('/cycle_count/createCycleCount/v1/', { param: cleanedPayload })
      .then((response) => {
        if (response.data.status_code === 201) {
          this.setState({
            failedMessage: response.data.reason,
          });
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length === 0
        ) {
          this.setState({
            alertMessage: "Are you sure you want to confirm ? ",
          });
          this.toggleAssignUserCycleCount();
          this.messageToggleCycle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length > 0
        ) {

          if (response.data.reason == "") {
            this.setState({
              failedMessage: response.data.failed[0].reason,
              showBinTable: false,
              showZone: false,
              showFailedItemCycle: true,
              FailedItems: response.data.failed,
            });

          } else {

            this.setState({
              failedMessage: response.data.reason,
              showBinTable: false,
              showZone: false,
              showFailedItemCycle: true,
              FailedItems: response.data.failed,
            });
          }
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();
        }
      })
      .catch(function (error) { });
  }

  togglePressCancel() {
    this.setState({
      modal: false,
      selectedOptions: "",
      selectedUser: {},
    });
  }

  handleChange(evt) {
    const files = evt.target.files;
    var file1 = evt.target.value;
    this.setState({
      btnDisabled: true,
      loading_overlay: true,
    }, () => {

      if (files && files[0]) {
        this.setState({
          file: files[0]
        })
      } else {
        this.setState({
          loading_overlay: false,
          btnDisabled: false,
          file: {},
        })
        $(".upload_success").css('display', 'none');
        $(".upload_error").css('display', 'none');
        $('.button_enable').removeAttr('disabled', 'disabled');
        return false;
      };

      var fileArray1 = file1.split(".");
      var extension1 = fileArray1[fileArray1.length - 1];

      if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color = "";
        document.getElementById("my_file_input").style.width = "85%";
        document.getElementById("picking_label").style.display = "none";
      } else {
        document.getElementById("my_file_input").style.width = "26%";
      }

      if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
        $(".upload_error").css("display", "block");
        $(".upload_success").css("display", "none");
      } else {
        $(".upload_success").css("display", "block");
        $(".upload_error").css("display", "none");
        $(".button_enable").removeAttr("disabled", "disabled");
      }

      this.setState({
        btnDisabled: false,
        loading_overlay: false,
      });
    });
  }

  onChangeVal1 = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };

  onChangeVal = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };

  onChangeValStock = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };

  onSelectProcess = selected => {
    this.setState({
      selectedOptionType: selected.value,
      selectedOptionValue: selected.value,
      onSelectProcessVal: selected,
    })
  }

  onSelectZone = selected => {
    this.setState({
      selectedZone: selected.value,
      zoneTypeFlag: true
    })
  }


  onZoneSelect = () => {
    this.setState({
      optionSelected: null,
      selectedaisle: "",
      selected_rack: ""
    })
    options=[];
    const payload = {
      location: "",
      zone_type: this.state.selectedZone
    }
    API.post('/cycle_count/cycleCountParameters/v1/', { param: payload })

      .then((response) => {
        for (var i = 0; i < response.data.zones.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          orderData["label"] = response.data.zones[i].zone_code;
          orderData["value"] = response.data.zones[i].zone_no;
          orderData["id"] = response.data.zones[i].id;

          options.push(orderData);
        }

        this.setState({
          genloading4: false,
          showDashboardData: false,
          showZone: true,
          showBinAddressDropdown: false,
          showProcess: true,
        });

        /* console.log(this.state.options);*/

        for (var i = 0; i < response.data.racks.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          orderData["label"] = response.data.racks[i].rack_aisle;
          orderData["value"] = response.data.racks[i].rack_aisle;
          orderData["rackCode"] = response.data.racks[i].rack_code;
          orderData["aisle"] = response.data.racks[i].aisle__aisle_code;
          orderData["zone__zone_no"] = response.data.racks[i].zone__zone_no;

          options2.push(orderData);
        }

        for (var i = 0; i < response.data.aisles.length; i++) {
          // <---- Move declaration inside loop

          if (response.data.aisles[i].aisle_code !== null) {
            var orderData = {};
            orderData["label"] = response.data.aisles[i].aisle__aisle_code;
            orderData["value"] = response.data.aisles[i].id;
            orderData["zone"] = response.data.aisles[i].zone__zone_no;

            options1.push(orderData);
          }
        }
      })
      .catch(function (error) { });

  }

  onChangeVal3 = (selected) => {
    const { selectedUser } = this.state;

    let selectedLabel = selected.map((item) => item.value);
    let unique_aisle = [];
    let new_selectedZone = []
    let selectedZone = options1.filter(
      (item) => selectedLabel.indexOf(item.zone) != -1
    );


    for (let i = 0; i < selectedZone.length; i++) {
      if (unique_aisle.indexOf(parseInt(selectedZone[i]["value"])) <= -1) {
        unique_aisle.push(parseInt(selectedZone[i]["value"]));
        new_selectedZone.push(selectedZone[i]);
      } else {
        selectedZone.splice(i, 1);
      }
    }

    this.setState({
      options1: new_selectedZone,
      showAisle: true,
      showRack: false,
      showSubmitBtn: false,
      removeSelectedDate: true,
      clearData: true,
      zoneDataVal: selected,
      optionSelected: selected,
      showBinAddressDropdown: false,
    });

    zone_arr = [];

    for (var i = 0; i < selected.length; i++) {
      zone_arr.push(selected[i].id);
    }
    /*selectedUser[id] = options.map(item => item.value)
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))*/
  };
  onValueChange1 = (e) => {
    this.setState({ selectedaisle: e.target.value });

  }
  onValueChange2 = (e) => {
    this.setState({ selected_rack: e.target.value });

  }
  onChangeVal1 = (selected) => {
    const { selectedUser } = this.state;

    let selectedLabel = [];

    for (let i = 0; i < this.state.optionSelected.length; i++) {
      let mapped_data = selected.map((item) => item.label + this.state.optionSelected[i].value);
      for (let j = 0; j < mapped_data.length; j++) {
        selectedLabel.push(mapped_data[j]);
      }
    }

    let selectedRack = options2.filter(
      (item) => selectedLabel.indexOf(item.aisle + item.zone__zone_no) != -1
    );
    let unique_aisle = [];
    let new_selectedRack = [];
    for (let i = 0; i < selectedRack.length; i++) {
      if (unique_aisle.indexOf(selectedRack[i]["value"].toString()) <= -1) {
        unique_aisle.push(selectedRack[i]["value"].toString());
        new_selectedRack.push(selectedRack[i]);
      } else {
        selectedRack.splice(i, 1);
      }
    }
    // console.log(options2);

    //console.log(options);

    this.setState({
      options2: new_selectedRack,
      showRack: true,
      optionSelected1: selected,
    });

    //console.log(selectedRack);
    //console.log(this.state.options2);
    aisles_arr = [];

    for (var i = 0; i < selected.length; i++) {
      aisles_arr.push(selected[i].value);
    }

    /*selectedUser[id] = options.map(item => item.value)
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))*/
  };

  onChangeVal2 = (selected) => {
    const { selectedUser } = this.state;

    this.setState({
      showBinTable: false,
      showSubmitBtn: true,
      optionSelected2: selected,
    });

    racks_arr = [];
    racks_aisle = [];
    for (var i = 0; i < selected.length; i++) {
      racks_arr.push(selected[i].rackCode);
      racks_aisle.push(selected[i].label);
    }

    /*selectedUser[id] = options.map(item => item.value)
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))*/
  };

  btnClick(putAwayId, Status) {
    /* options=[];*/
    if (Status === "UNHOLD") {
      this.setState({
        changeStatus: "hold",
      });
    } else {
      this.setState({
        changeStatus: "unhold",
      });
    }

    var arr = [];
    var orderData = {};
    orderData["putawayHistoryId"] = putAwayId;

    if (Status === "UNHOLD") {
      orderData["changeStatus"] = "hold";
    } else {
      orderData["changeStatus"] = "unhold";
    }

    arr.push(orderData);

    const payload = {
      arr_data: arr,
      location: this.state.selectedLocation,
      create: true,
    };

    API.post('/picking/updateHoldStatus/v1/', { param: payload })
      .then((response) => {
        /*alert(response.data.success_response[0].message);*/
        this.setState({
          alertMessage: response.data.success_response[0].message,
          messageModal: true,
        });

        this.fetchGRNData();
      })
      .catch(function (error) { });
  }

  checkAll() {
    if (this.state.ischeckedbin === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
        ischeckedbin: true
      });
      this.setState({ binData: "" })
      bin_array = []
      let newBinData = this.state.bin_address_list.map((item) => ({
        ...item,
        isChecked: true,
      }));

      for (var i = 0; i < newBinData.length; i++) {
        bin_array.push(newBinData[i]);
      }


      this.setState({
        binData: bin_array,
        SelectedBins: newBinData,
      });
      this.setState({
        isdisableAssignBtn: false,
      });

      this.setState({
        genloading7: !this.state.genloading7,
        bin_address_list: newBinData,
        isdisableAssignBtn: false,
        showSelectedBin: true,
        //binData: bin_array, 
        showCross: false

      });
    } else if (this.state.ischeckedbin === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
        ischeckedbin: false
      });

      let newBinData = this.state.bin_address_list.map((item) => ({
        ...item,
        isChecked: false,
      }));

      for (var i = 0; i < newBinData.length; i++) {
        bin_array.splice(bin_array.findIndex(a => a.id === newBinData[i].id), 1)
      }

      this.setState({
        binData: bin_array,
      });

      this.setState({
        genloading7: !this.state.genloading7,
        bin_address_list: newBinData,
        isdisableAssignBtn: false,
        //showSelectedBin: false,
        binData: bin_array,
        showCross: false

      });

      if (bin_array.length > 0) {
        this.setState({
          showSelectedBin: true,
          isdisableAssignBtn: false,
        })
      } else {
        this.setState({
          showSelectedBin: false,
          isdisableAssignBtn: true,
        })
      }


    }
  }



  fetchGRNData() {
    var grnVal = localStorage.getItem("grnValues");
    this.setState({
      showFetchGRNData: true,
      loadingGRNData: true,
    });

    const payload = {

    };

    API.post('/picking/fetchgrnInfo/v1/', { param: payload })

      .then((response) => response.data)

      .then((data) => {

        this.setState({
          postsGRN: data,
          grnValues: data[0].grnNumber,
          grnLineValue: data[0].gnrLineNumber,
        });
      })

      .then(async () => {
        this.setState({
          tableRowsGRN: this.assemblePostsGRN(),
          isLoading: false,
          loadingGRNData: false,
        });

      });
  }

  assemblePostsGRN = () => {
    let postsGRN = this.state.postsGRN.map((post, index) => {
      return {
        serial: index + 1,

        status:
          post.status == "UNHOLD" ? (
            <span
              onClick={(r) => this.btnClick(post.putawayHistoryId, post.status)}
              style={{ color: "red", cursor: "pointer" }}
            >
              Hold
            </span>
          ) : (
            <span
              style={{ color: "green", cursor: "pointer" }}
              onClick={(r) => this.btnClick(post.putawayHistoryId, post.status)}
            >
              Unhold
            </span>
          ),

        binId: post.binId,

        zone_name: post.zoneName,

        zone_id: post.zoneId,

        lbskuid: post.lbSKUId,

        batch: post.batch,

        mrp: post.mrp,

        receivedIcldQuantity: post.receivedIcldQuantity,

        testerQuantity: post.testerQuantity,

        looseQuantity: post.looseQuantity,

        stnDate: post.stnDate,

        stnNumber: post.stnNumber,

        pkd: post.pkd,

        upc: post.upc,

        total_quantity: post.binFilledQty,

        /*grnDateTime: post.grnDateTime,*/

        /*basePackDesc: post.basePackDesc,*/

        fastMoving: post.fastMoving,

        crateId: post.crateId,
      };
    });

    return postsGRN;
  };

  fetchCycleCountDashboard() {
    const payload = {
      location: this.state.selectedLocation,
    };

    API.post('/cycle_count/cycleDashboard/v1/', { param: payload })

      .then((response) => response.data)

      .then((data) => {

        this.setState({ postsProduct: data });

        var filterPostData = [];

        filterPostData = data.filter((item) => item.status === "Active");

        if (filterPostData.length > 0) {
          this.setState({
            disabledSubmitBtn: true,
          });
        }
      })

      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
        });

      });
  }


  TaskConfirmClick = (id) => {
    localStorage.setItem('batch', id); window.location.href = "/maintenance/cycleCountConfirmation";
  };
  assemblePostsProduct = () => {

    let postsProduct = this.state.postsProduct.map((post) => {
      return {
        report:
          post.status == "Completed" ? (
            <span
              onClick={(r) => this.toggleReports(post.id)}
              class="lnr lnr-download"
              style={{ color: "#0F52BA", fontSize: 22, fontWeight: "bold", marginLeft: '50px' }}
            ></span>
          ) : (
            <span
              class="lnr lnr-download isDisabled"
              style={{ color: "#0F52BA", fontSize: 22, fontWeight: "bold", marginLeft: '50px', opacity: 0.3 }}
            ></span>
          ),
        action:
          post.status == "Active" ? (
            <span
              onClick={(r) => this.onCancelCycleModal(post.id)}
              class="lnr lnr-cross"
              style={{ color: "red", fontWeight: "bold" }}
            ></span>
          ) : (
            <span></span>
          ),
        batch: post.status == "Active" ? (
          <a
            style={{ cursor: "pointer", color: "rgb(62, 163, 252)" }}
            onClick={() => this.TaskConfirmClick(post.id)}
          >
            {post.id}
          </a>
        ) : (post.id),
        status:
          post.status == "Active" ? (
            <span style={{ color: "orange", fontWeight: "bold" }}>
              {post.status}
            </span>
          ) : (
            <span
              style={{
                color: post.status == "Completed" ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              {" "}
              {post.status}
            </span>
          ),
        added_on: post.added_on,
        task_created: post.task_created,

        users: post.users,

        task_pushed: post.task_pushed,

        update_from_mobile: post.update_from_mobile,

        reconciled: post.reconciled,

        reconciled_processed: post.reconciled_processed,

        recheck: post.recheck,

      };
    });

    return postsProduct;
  };


  handleFile = () => {
    if (this.state.file.name === undefined || this.state.file.name === null) {
      this.setState({
        responseModal: true,
        responseModalMsg: "Select at least one File"
      });
      return false;
    }
    this.setState({
      loading: true,
      //loading_overlay: true,
      show_error_list: false,
      show_bin_list: false,
      show_upload_error_list: false,
      product_code: "",
      mrp: "",
      product_brand: "",
      category: "",
      sub_category: "",
      division: "",
      parent_code: ""
    });
    const ref = this;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        dateNf: "YYYY-MM-DD"
      });

      var XL_row_object = XLSX.utils.sheet_to_row_object_array(
        wb.Sheets[wsname],
        { header: 1, blankRows: false }
      );
      var json_object = XL_row_object;


      var mandatory_field = false;
      var uploaded_file_header = json_object[0];

      /* if (this.state.selectedOption.value === "product_master") {
    var sample_file_header = Object.keys(this.state.product_master_header[0]);
    }else if (this.state.selectedOption.value === "base_pack_zone") {
    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    }else if (this.state.selectedOption.value === "tester_basepack_master") {
    var sample_file_header = Object.keys(this.state.tester_header[0]);
    }else if (this.state.selectedOption.value === "bin_master") {
    var sample_file_header = Object.keys(this.state.bin_master_header[0]);
    } */

      var sample_file_header = Object.keys(this.state.product_header[0]);

      if (parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length)) {
        ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
          loading_overlay: false,
        });
        /*if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');*/
        return false;
      }
      for (let i = 0; i < uploaded_file_header.length; i++) {
        if (uploaded_file_header[i] !== sample_file_header[i]) {
          ref.setState({
            loading: false,
            responseModal: true,
            responseModalMsg: "Invalid Format",
            loading_overlay: false,
          });
          return false;
        }
      }

      /* Update state */
      this.setState({ data: data, cols: make_cols(ws["!ref"]) }, () => {
        /*let invalidItems = this.state.data.filter(
          (item) => !this.validateItem(item)
        );*/
        /*if(invalidItems.length > 0){

          console.log("Invalid Items", invalidItems)
          this.setState({
            showInvalidItem: true,
            showResponseData: true,
            invalidItemList: invalidItems

          })
        }else{
          console.log("Valid items");
           this.setState({
            showInvalidItem: false,

          })*/

        //if (this.state.selectedOption.value === "base_pack_zone") {
        /* if (invalidItems.length > 0) {
           console.log(invalidItems);
           this.setState({
             showRowDataErrorBase: false,
             showRowDataErrorProduct: false,
             showRowDataErrorTester: false,
             showRowDataError: false,
             showResponseData: true,
             ErrorRowData: invalidItems,
             showResponseData: false,
             showInvalidItem: false,
             showBaseResponseData: false,
             showInvalidBaseItem: false,
             showInvalidProductItem: false,
             showInvalidTesterItem: false,
             showProductResponseData: false,
             showFetchBaseData: false,
             showFetchProductData: false,
             showFetchTesterData: false,
             showFetchBinData: false,
           });

           console.log(Object.keys(invalidItems));
           
         }*/


        var arr = [];

        for (var i = 0; i < this.state.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};
          /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
          orderData["zoneName"] = this.state.data[i]["ZoneName"];
          orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

          if (this.state.data[i]["Product Code"] == undefined || this.state.data[i]["Product Code"] == null) {
            orderData["sku7_code"] = "";
          } else {
            orderData["sku7_code"] = this.state.data[i]["Product Code"];
          }

          if (this.state.data[i]["MRP"] == undefined || this.state.data[i]["MRP"] == null) {
            orderData["mrp"] = "";
          } else {
            orderData["mrp"] = this.state.data[i]["MRP"];
          }

          orderData['zone_type'] = this.state.selectedZone;

          arr.push(orderData);
        }

        console.log(arr);
        var arr_data = JSON.stringify(arr);



        API.post('/cycle_count/CycleCountUpload', { param: arr })
          .then((response) => {

            this.setState({
              showBaseResponseData: true,
              showInvalidBaseItem: false,
              showInvalidTesterItem: false,
              showTesterResponseData: false,
              loading: false,
              showResponseData: false,
              showInvalidItem: false,
              showProductResponseData: false,
              //showInvalidProductItem: false,
              showRowDataError: false,
              showRowDataErrorBase: false,
              showRowDataErrorProduct: false,
              showInvalidProductItem: true,
              responseFailProductData: response.data.data,
              showRowDataErrorTester: false,
              responseFailBaseData: response.data,
              responseSuccessBaseData: response.data,
              show_process_data: true,
            });

            if (response.data.success == false) {
              this.cancelToggle();
              this.setState({
                cancelReason: response.data.message,
                upload_error_list: response.data.data,
                show_upload_error_list: true,
                show_error_list: false,
                show_bin_list: false

              })
            } else {
              //this.successToggle();
              let newBinData = response.data.data.map((item) => ({
                ...item,
                isChecked: false,
              }));
              this.setState({
                bin_address_list: newBinData,
                show_bin_list: true,
                show_error_list: false,
                show_upload_error_list: false
              })
            }

            /*if (response.data.failure_response.length > 0) {
              this.toggleFailed();
            } else {
              this.toggle();
            }

            if (response.data.success_response.length > 0) {
              this.setState({
                show_process_data: true,
              });
            } else {
              this.setState({
                show_process_data: false,
              });
            } */
            /*this.setState({
              file: {}, // Clear file from state
              loading_overlay: false,
            }, () => {
              if (this.fileInput) {
                this.fileInput.value = ""; // Reset file input field
              }
            });
            if (document.getElementById("my_file_input") !== null) {
              document.getElementById("my_file_input").style.color =
                "transparent";
              document.getElementById("picking_label").style.display = "inline-block";
              document.getElementById("picking_label").innerHTML =
                "Select and Upload Picksheet";
            }
            document.getElementById("my_file_input").style.width = "26%";
            $(".upload_error").css('display', 'none');
            $(".upload_success").css('display', 'none');*/
            /*this.fetchBaseData();*/
          })
          .catch(function (error) {

            if (document.getElementById("my_file_input") !== null) {
              document.getElementById("my_file_input").style.color =
                "transparent";
              document.getElementById("picking_label").style.display = "inline-block";
              //document.getElementById("picking_label").innerHTML =
              //"Select and Upload Picksheet";
            }

            $(".upload_error").css('display', 'none');
            $(".upload_success").css('display', 'none');
          });








        /*}*/
      });
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }

  toggle() {
    this.setState({
      selectedUser: {},
      selectedOptions: "",
      modal: true,
      newArrayData1: [],
    });
    this.setState((prevState) => ({ messageModal: !prevState.messageModal, modal: !prevState.modal }));
    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData = this.state.postsGRN.filter(
      (item) => item.status === "UNHOLD" && item.zoneName != null
    );
    this.setState({
      newArrayData1: arrayCartData,
    });
  }

  handleChangeEvent = (evt) => {
    this.setState({ [evt.target.name]: evt.target.value })

  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  removeBin = bin_address => {
    let bin_address_arr = [...this.state.binData];
    let selected_bins = [...this.state.SelectedBins];
    for (let i = 0; i < bin_address_arr.length; i++) {
      if (bin_address_arr[i] != "" && bin_address_arr[i] != undefined) {
        if (bin_address_arr[i]["bin_address"] == bin_address) {
          bin_address_arr.splice(i, 1);
        }
      }
      if (selected_bins[i] != "" && selected_bins[i] != undefined) {
        if (selected_bins[i]["bin_address"] == bin_address) {
          selected_bins.splice(i, 1);
        }
      }
    }

    this.setState({
      binData: bin_address_arr,
      SelectedBins: selected_bins
    }, () => {
      if (this.state.SelectedBins.length == 0) {
        this.setState({
          showSelectedBin: false,
        })
      }
    });
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const {
      showPassword,
      newArrayData,
      newArrayData1,
      selectedUser,
      modalReport,
    } = this.state;
    const { modal, modalCancel } = this.state;
    const { modalAssignUser, modalAssignUserCycleCount } = this.state;
    const {
      messageModal,
      modalfailed,
      successModal,
      modalfailedCycle,
      messageModalCycle,
      cycleCountCancelModal,
    } = this.state;
    const uniqueZoneData1 = {};
    const uniqueZoneData = {};
    newArrayData.map((item) => {
      if (!uniqueZoneData[item.zone_id]) {
        uniqueZoneData[item.zone_id] = {
          zoneId: item.zone_no,
          zoneName: item.zone_code,
          id: item.zone_id,
          items: [],
        };
      }
      uniqueZoneData[item.zone_id].items.push(item);
    });

    newArrayData1.map((item) => {
      if (!uniqueZoneData1[item.zone_id]) {
        uniqueZoneData1[item.zone_id] = {
          zoneId: item.zone_id,
          zoneName: item.zone__zone_code,
          items: [],
        };
      }
      uniqueZoneData1[item.zone_id].items.push(item);
    });

    const productData = {
      columns: [
        {
          label: "Download Reports",

          field: "report",

          width: 150,
        },
        {
          label: "Action",

          field: "action",

          width: 80,
        },

        {
          label: "Batch",

          field: "batch",

          width: 100,
        },

        {
          label: "Status",

          field: "status",
          width: 100,
        },

        {
          label: "Added on",

          field: "added_on",
          width: 180,
        },

        {
          label: "Task Created",

          field: "task_created",

          width: 150,
        },

        {
          label: "Users",

          field: "users",

          width: 110,
        },

        {
          label: "Task Pushed",

          field: "task_pushed",

          width: 150,
        },

        {
          label: "Updated From Mobile",

          field: "updated_from_mobile",

          width: 180,
        },

        {
          label: "Reconciled",

          field: "reconciled",

          width: 100,
        },

        {
          label: "Reconciled Processed",

          field: "reconciled_processed",

          width: 180,
        },

        {
          label: "Recheck",

          field: "recheck",

          width: 100,
        },


      ],

      rows: this.state.tableRowsProduct,
    };

    const GRNData = {
      columns: [
        /* {

          label:'GRN Number',

          field:'grnNumber',

        },

        {

          label:'GRN Line Number',

          field:'gnrLineNumber',

        },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/
        {
          label: "S No.",

          field: "serial",
          width: 180,
        },

        {
          label: "Action",

          field: "status",
          width: 180,
        },

        {
          label: "BIN Id",

          field: "binId",
          width: 180,
        },

        {
          label: "Zone Name",

          field: "zone_name",
          width: 180,
        },

        {
          label: "Zone Id",

          field: "zone_id",
          width: 180,
        },

        {
          label: "LB SKU ID",

          field: "lbskuid",
          width: 180,
        },

        {
          label: "Batch",

          field: "batch",
          width: 180,
        },

        {
          label: "MRP",

          field: "mrp",
          width: 180,
        },

        {
          label: "ICLD Quantity (Box)",

          field: "receivedIcldQuantity",
          width: 180,
        },

        {
          label: "Tester Quantity (pcs)",

          field: "testerQuantity",
          width: 180,
        },

        {
          label: "Loose Quantity (pcs)",

          field: "looseQuantity",
          width: 180,
        },

        {
          label: "STN Date",

          field: "stnDate",
          width: 180,
        },

        {
          label: "STN Number",

          field: "stnNumber",
          width: 180,
        },

        {
          label: "PKD",

          field: "pkd",
          width: 180,
        },

        {
          label: "UPC",

          field: "upc",
          width: 180,
        },

        {
          label: "Total Quantity (pcs)",

          field: "total_quantity",
          width: 180,
        },

        /*{

          label:'GRN Date Time',

          field:'grnDateTime',

        },*/

        /*{

          label:'Base Pack Desc',

          field:'basePackDesc',

        },*/

        {
          label: "Fast Moving",

          field: "fastMoving",
          width: 180,
        },

        {
          label: "Crate Id",

          field: "crateId",
          width: 180,
        },
      ],

      rows: this.state.tableRowsGRN,
    };

    const selectedOptionsStyles = {
      color: "#3c763d",
      backgroundColor: "#dff0d8",
    };
    const optionsListStyles = {
      backgroundColor: "#dff0d8",
      color: "#3c763d",
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' />}
        <Card>


          {this.state.showDashboardData && (
            <CardBody style={{ marginTop: 20, display: 'none' }}>
              <div className="table_header">
                <h4 style={{ fontWeight: "bold" }} className="subhead red-text">
                  Cycle Count Data
                </h4>
              </div>
              <MDBDataTable
                striped
                bordered
                hover
                data={productData}
                scrollX={true}
              />
            </CardBody>
          )}

          <div className="row">
            {this.state.showProcess && (
              <div className="col-xl-12" style={{ marginBottom: 6 }}>
                <CardBody style={{ height: 68 }}>

                  {this.state.showProcess && (
                    <div className="form__form-group col-xl-12">
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", }}
                    >
                       <span
                        className="form__form-group-label col-xl-2"
                        style={{
                          display: "inline", paddingTop: 0,

                        }}
                      >
                        Zone Type
                      </span>

                      <div
                        className="form__form-group-field col-xl-8"
                        style={{ display: "inline", marginTop: -10 }}
                      >
                        <MySelect
                          style={{ width: "100%", marginTop: -10 }}
                          //options={[{"label":"Select by Bin","value":"1"},{"label":"Select by Zone","value":"2"},{"label":"Select by Product","value":"3"}, {"label":"Recommended Bins","value":"4"}, {"label":"All Bins (Stock Take)","value":"5"}, {"label":"Empty Bins","value":"6"}]}
                          //options={[{"label":"Select by Product","value":"3"}]}
                          options={this.state.zoneData}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onSelectZone}
                          
                        />
                      </div>
                      <div className="form__form-group-field col-xl-2">
                      </div>
                      </div>

                      <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", }}
                    >
                      {this.state.zoneTypeFlag &&
                        <span
                          className="form__form-group-label col-xl-2"
                          style={{
                            display: "inline", paddingTop: 0,

                          }}
                        >
                          Selection Mode
                        </span>
                      }

                      {this.state.zoneTypeFlag &&
                        <div
                          className="form__form-group-field col-xl-8"
                          style={{ display: "inline", marginTop: -10 }}
                        >
                          <MySelect
                            style={{ width: "100%", marginTop: -10 }}
                            //options={[{"label":"Select by Bin","value":"1"},{"label":"Select by Zone","value":"2"},{"label":"Select by Product","value":"3"}, {"label":"Recommended Bins","value":"4"}, {"label":"All Bins (Stock Take)","value":"5"}, {"label":"Empty Bins","value":"6"}]}
                            //options={[{"label":"Select by Product","value":"3"}]}
                            options={this.state.toSelectData}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={this.onSelectProcess}
                            value={this.state.selectedProcess}
                          />
                        </div>
                      }


                      {this.state.zoneTypeFlag &&
                      <div
                        className="form__form-group-field col-xl-2"
                        style={{ display: "inline", marginTop: -10 }}
                      >
                        <ButtonToolbar
                          className="form__button-toolbar"
                          style={{ height: 30 }}
                        >
                          <button
                            color="primary"
                            disabled={this.state.disabledSubmitBtn}
                            className="btn-sm button_enable "
                            style={{
                              borderRadius: 5,
                              backgroundColor: "#70bbfd",
                              color: "#fff",
                            }}
                            id="button_enable"
                            onClick={this.onSubmitBtn2}
                          >
                            {this.state.genloading4 && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            Search
                          </button>
                        </ButtonToolbar>
                      </div>
                    }
                    </div>
                    </div>
                  )}

                </CardBody>
              </div>
            )}
          </div>


          {this.state.showBinAddressDropdown && (
            <div class="row">
              <div className="col-xl-12">
                <CardBody style={{ height: 65 }}>

                  <div
                    className="form__form-group col-xl-12"
                    style={{ display: "inline-flex", }}
                  >
                    <span
                      className="form__form-group-label col-xl-3"
                      style={{
                        display: "inline",
                      }}
                    >
                      Bin Address
                    </span>

                    <div
                      className="form__form-group-field col-xl-9"
                      style={{ display: "inline", marginTop: -10 }}
                    >
                      <input
                        placeholder="Select Bin Address"
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        value={this.state.selectedBinAddress}
                        onChange={this.onBinAddressKeyup}
                        onBlur={this.onBlurBinAddress}
                      />

                      {this.state.containerOnKeyDown && (
                        <div
                          className="suggestions-container"
                          style={{ height: 150, width: "100%" }}
                          ref={(el) => (this.typeahead = el)}
                        >
                          <div className="suggestions">
                            {this.state.optionForBinAddressDropdown.length >
                              0 &&
                              this.state.optionForBinAddressDropdown.map(
                                (item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.onSelectBinAddress([item])
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.label}{" "}
                                  </p>
                                )
                              )}
                          </div>
                        </div>
                      )}


                    </div>
                  </div>
                </CardBody>
              </div>
            </div>
          )}



          {this.state.showProductDropdown && (
            <div class="row">
              <div className="col-xl-12">
                <CardBody style={{ paddingBottom: 15 }}>

                  <div
                    className="form__form-group"
                    style={{ display: "inline-flex", width: '100%', float: 'left', marginTop: -10 }}
                  >
                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '12%',
                        float: 'left'
                      }}
                    >
                      Product Code
                    </span>

                    <div
                      style={{
                        width: '13%',
                        float: 'left'
                      }}
                    >
                      <input

                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 30,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        name="product_code"
                        value= {this.state.product_code}
                        onChange={this.handleChangeEvent}
                        onBlur={this.onBlurBinAddress}
                      />




                    </div>





                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '12%',
                        float: 'left',
                        marginLeft: 15
                      }}
                    >
                      MRP
                    </span>

                    <div
                      style={{
                        width: '13%',
                        float: 'left'
                      }}
                    >
                      <input

                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 30,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        name="mrp"
                        value= {this.state.mrp}
                        onChange={this.handleChangeEvent}
                        onBlur={this.onBlurBinAddress}
                      />




                    </div>


                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '12%',
                        float: 'left',
                        marginLeft: 15
                      }}
                    >
                      Product Brand
                    </span>

                    <div
                      style={{
                        width: '13%',
                        float: 'left'
                      }}
                    >
                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 30,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        onChange={this.handleChangeEvent}
                        name="product_brand"
                        value= {this.state.product_brand}
                        onBlur={this.onBlurBinAddress}
                      />




                    </div>

                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '12%',
                        float: 'left',
                        marginLeft: 15
                      }}
                    >
                      Category
                    </span>

                    <div
                      style={{
                        width: '13%',
                        float: 'left'
                      }}
                    >
                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 30,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        name="category"
                        value= {this.state.category}
                        onChange={this.handleChangeEvent}

                        onBlur={this.onBlurBinAddress}
                      />




                    </div>
                  </div>


                  <div
                    className="form__form-group"
                    style={{ display: "inline-flex", marginTop: "-10px", marginBottom: '0px', width: '100%', float: 'left' }}
                  >


                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 2,
                        paddingBottom: 6,
                        width: '12%',
                        float: 'left',
                      }}
                    >
                      Sub Category
                    </span>

                    <div
                      style={{
                        width: '13%',
                        float: 'left'
                      }}
                    >
                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          width: "100%",
                          height: 30,
                          marginLeft: -6,
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        onChange={this.handleChangeEvent}
                        name="sub_category"
                        value= {this.state.sub_category}

                        onBlur={this.onBlurBinAddress}
                      />




                    </div>




                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '11%',
                        float: 'left',
                        marginLeft: 15
                      }}
                    >
                      Division
                    </span>

                    <div
                      style={{
                        width: '12%',
                        float: 'left'
                      }}
                    >
                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 30,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        onChange={this.handleChangeEvent}
                        name="division"
                        value= {this.state.division}

                        onBlur={this.onBlurBinAddress}
                      />




                    </div>


                    <span
                      className="form__form-group-label"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '12%',
                        float: 'left',
                        marginLeft: 16
                      }}
                    >
                      Parent Code
                    </span>

                    <div
                      style={{
                        width: '12%',
                        float: 'left'
                      }}
                    >
                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 30,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        name="parent_code"
                        value= {this.state.parent_code}
                        onChange={this.handleChangeEvent}
                        onBlur={this.onBlurBinAddress}
                      />




                    </div>


                    <div
                      style={{
                        width: '12%',
                        float: 'left', marginLeft: 20
                      }}
                    >
                      <ButtonToolbar
                        className="form__button-toolbar"
                        style={{ height: 30 }}
                      >
                        <button
                          color="primary"
                          disabled={this.state.disabledSubmitBtn}
                          className="btn-sm button_enable "
                          style={{
                            borderRadius: 5,
                            backgroundColor: "#70bbfd",
                            color: "#fff",
                          }}
                          id="button_enable"
                          onClick={this.onSubmitBtn}
                        >
                          {this.state.genloading && (
                            <i
                              className="fa fa-refresh fa-spin"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Search
                        </button>
                      </ButtonToolbar>




                    </div>
                  </div>

                  <div
                    style={{
                      width: '100%',
                      float: 'left', marginLeft: 20, marginTop: 5, marginBottom: 5, fontWeight: 'bold'
                    }}
                  >
                    <span> OR </span>





                  </div>

                  <div style={{ width: '100%', float: 'left' }}>


                    <div style={{ width: '44%', float: 'left', flexDirection: 'column' }}>
                      <div className="form__form-group"
                        style={{ width: '70%', float: 'left', border: "1px solid #f2f4f7" }}
                      >
                        <input
                          style={{
                            paddingTop: 8,
                            height: 38,
                            color: "transparent",
                            width: "26%",
                            border: "0px",
                          }}
                          name="defaultInput"
                          component="input"
                          type="file"
                          placeholder="Default Input"
                          ref={ref => this.fileInput = ref}

                          id="my_file_input"
                          onChange={this.handleChange}
                        />
                        <label for="files" id="picking_label">
                          Select and Upload Product Data
                        </label>
                      </div>
                      <div style={{width: '100%', float: 'left'}} className="col-xl-12">
                        <span
                          style={{ display: "none", color: "red" }}
                          className="upload_error"
                        >
                          {" "}
                          Invalid file format. Please select .xls, .xlsx, .csv file
                          format{" "}
                        </span>
                        <span
                          style={{ display: "none", color: "green", marginTop: 8 }}
                          className="upload_success"
                        >
                          {" "}
                          Valid file format{" "}
                        </span>
                      </div>
                    </div>

                    <div className="form__form-group" style={{ width: '20%', float: 'left', paddingLeft: 12 }}>
                      <ButtonToolbar className="form__button-toolbar">
                        <button
                          color="primary"
                          className="btn-sm button_enable "
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            borderRadius: 5,
                            backgroundColor: "#70bbfd",
                            color: "#fff",
                            padding: "5px 25px",
                            fontSize: "14px",

                          }}
                          id="button_enable"
                          onClick={this.handleFile}
                          disabled={this.state.btnDisabled}
                        >
                          {this.state.loading && (
                            <i
                              className="fa fa-refresh fa-spin"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Submit
                        </button>
                      </ButtonToolbar>
                    </div>
                  </div>

                  <div style={{ paddingLeft: "17px" }}>
                    <button
                      color="primary"
                      className="download_sample_styling button_enable "
                      style={{
                        backgroundColor: "#fff",
                        marginTop: 4,
                        marginBottom: 7,
                        fontWeight: "500",
                        textDecoration: "underline",
                        textTransform: "capitalize",
                      }}
                      onClick={(e) =>
                        exportToCSV(
                          this.state.product_header,
                          "CC_Product_Template"
                        )
                      }
                    >
                      Sample Template
                    </button>

                  </div>









                </CardBody>
              </div>
            </div>
          )}


          <div className="row">
            {this.state.showZone && (
              <div className="col-xl-12" style={{ marginBottom: 20 }}>
                <CardBody id="zone_card_body" style={{ marginTop: 20, height: 100 }}>

                  <div
                    className="form__form-group col-xl-12"
                    style={{ display: "inline-flex", marginTop: "10px", width: '100%', float: 'left' }}
                  >
                    <span

                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '6%',
                        float: 'left'
                      }}
                    >
                      Zone
                    </span>

                    <div
                      style={{ display: "inline", width: '20%', float: 'left', marginRight: 20 }}
                    >
                      <MySelect

                        options={options}
                        isMulti
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={this.onChangeVal3}
                        allowSelectAll={true}
                        value={this.state.optionSelected}
                        styles={{
                        valueContainer: (base) => ({
                          ...base,
                          maxHeight: 80,
                          overflowY: 'auto',
                          flexWrap: 'wrap',
                        }),
                        control: (base, state) => ({
                          ...base,
                          minHeight: 38,
                          overflow: 'hidden',
                          flexWrap: 'wrap',
                          borderColor: state.isFocused ? '#2684FF' : base.borderColor,
                          boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : base.boxShadow,
                        }),
                        multiValue: (base) => ({
                          ...base,
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }),
                      }}
                      />
                     {/* <Select
                      isMulti
                      options={options}
                      value={this.state.optionSelected}
                      onChange={(selectedOptions) => {
                        const brandNames = selectedOptions.map(option => option.value).join(',');
                        this.setState({
                          selectedBrands: selectedOptions,
                          selectedBrandNames: brandNames,
                        });
                      }}
                      closeMenuOnSelect={false}
                      menuPlacement="auto"
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          maxHeight: 80,
                          overflowY: 'auto',
                          flexWrap: 'wrap',
                        }),
                        control: (base, state) => ({
                          ...base,
                          minHeight: 38,
                          overflow: 'hidden',
                          flexWrap: 'wrap',
                          borderColor: state.isFocused ? '#2684FF' : base.borderColor,
                          boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : base.boxShadow,
                        }),
                        multiValue: (base) => ({
                          ...base,
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }),
                      }}
                    />*/}
                    </div>




                    <span

                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '6%',
                        float: 'left'
                      }}
                    >
                      Aisle{" "}
                    </span>

                    <div
                      style={{ display: "inline", width: '20%', float: 'left', marginRight: 20 }}
                    >
                      {/* <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options1}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal1}
                          allowSelectAll={true}
                          value={this.state.optionSelected1}
                        /> */}

                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 37,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}

                        name="Aisle"
                        value={this.state.selectedaisle}

                        onChange={this.onValueChange1}
                        placeholder="Enter Aisle"
                      // onBlur={this.onBlurBinAddress}
                      />

                    </div>


                    <span

                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                        width: '6%'
                      }}
                    >
                      Rack{" "}
                    </span>

                    <div

                      style={{ display: "inline", width: '20%', float: 'left', marginRight: 20 }}
                    >
                      {/* <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options2}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal2}
                          allowSelectAll={true}
                          value={this.state.optionSelected2}
                        /> */}

                      <input
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          height: 35,
                          width: "100%",
                          fontSize: 13, borderColor: 'hsl(0,0%,80%)', borderStyle: 'solid', borderWidth: '1px'
                        }}
                        name="Rack"
                        onChange={this.onValueChange2}
                        value={this.state.selected_rack}
                        placeholder="Enter Rack"

                      />

                    </div>

                    <div

                      style={{ display: "inline", textAlign: "center", width: '13%', float: 'left' }}
                    >
                      <ButtonToolbar className="form__button-toolbar">
                        <Button
                          color="primary"
                          disabled={this.state.disabledBtn}
                          className="btn-sm show_confirm_button"
                          onClick={this.onSubmitCycleCount}
                          type="submit"
                        >
                          {this.state.loadBinData && (
                            <i
                              className="fa fa-refresh fa-spin"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Submit
                        </Button>
                      </ButtonToolbar>
                    </div>
                  </div>

                </CardBody>
              </div>
            )}
          </div>


          {this.state.showSelectedBin && (
            <CardBody style={{ marginTop: 5, paddingTop: 8, paddingLeft: 8, height: '54%', overflowY: 'auto' }}>
              <div style={{ width: "100%", marginTop: -8 }}>
                <span style={{ fontWeight: "bold", fontSize: 15 }}>
                  {" "}
                  Selected Bins ({this.state.binData.length}){" "}
                </span>
              </div>

              <div style={{ width: "100%", marginTop: -2 }}>
                {this.state.binData.map(
                  (item, index) =>
                    item.isChecked == true && (
                      <span
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: 13,
                          width: "12%",
                          float: "left",
                          backgroundColor: "#ccc",
                          borderRadius: 6,
                          paddingTop: 4,
                          paddingBottom: 2,
                          marginRight: 6,
                          marginBottom: 2,
                        }}
                      >
                        {" "}
                        {item.bin_address}{" "} {this.state.showCross && <a><i onClick={() => this.removeBin(item.bin_address)} class="fa fa-times" aria-hidden="true" style={{ float: 'right', paddingRight: '10px', paddingTop: '4px' }}></i></a>}
                      </span>
                    )
                )}
              </div>

              {this.state.isdisableBinAssignBtn &&
                <div
                  className="form__form-group col-xl-12"
                  style={{ display: "inline-flex", margin: '20px 0px', paddingLeft: '0px' }}
                >
                  <div
                    className="form__form-group-field col-xl-12"
                    style={{ display: "contents", textAlign: "center" }}
                  >
                    <ButtonToolbar className="form__button-toolbar">
                      <Button
                        color="primary"
                        className="btn-sm show_confirm_button"
                        onClick={this.AssignUser}
                        type="submit"
                      >
                        Assign
                      </Button>
                    </ButtonToolbar>
                  </div>
                </div>
              }
            </CardBody>
          )}


          {this.state.show_bin_list &&
            <CardBody style={{ marginTop: 6 }}>
              <div style={{ marginTop: -5 }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.AssignUser}
                    type="submit"
                  // disabled={this.state.isdisableAssignBtn}
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Assign
                  </Button>
                </ButtonToolbar>
              </div>

              <div style={{ width: 100, float: 'left', marginLeft: 12 }}>

                <input
                  type="checkbox"
                  checked={this.state.ischeckedbin}
                  style={{ float: 'left' }}

                  onChange={() => this.checkAll()}

                />

                <label style={{ padding: 8, marginLeft: 5, borderRadius: 6, width: 74, }}>Select All</label>
              </div>

              {this.state.bin_address_list.map((item, index) => (

                <div style={{ width: '20', float: 'left', marginLeft: 12, marginTop: 6 }}>


                  {this.state.selectedOptionType == 2 || this.state.selectedOptionValue == 4 &&
                    <input
                      type="checkbox"
                      checked={item.isChecked}
                      style={{ float: 'left' }}
                      onChange={() => this.checkedSingle(index, item.bin_address, item.id)}

                    />
                  }

                  <span style={{ padding: 6, marginLeft: 5, borderRadius: 6, width: 120, float: 'left' }}>{item.bin_address}</span>
                </div>

              ))}



            </CardBody>
          }



          {this.state.show_error_list &&
            <CardBody style={{ marginTop: 6 }}>
              <div>
                <h6 style={{ color: '#ec3e51' }}> {this.state.errorListMessage}</h6>
                <Table
                  responsive
                  className="table--bordered"
                  style={{ marginBottom: 75 }}
                >
                  <thead>
                    <tr>
                      <th>SkU7 code</th>
                      <th>MRP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.error_list.map((item, key) =>
                      <tr key={key}>
                        <td>{item.sku7_code}</td>
                        <td>{item.mrp} </td>
                      </tr>

                    )}

                  </tbody>
                </Table>
              </div>




            </CardBody>
          }

          {this.state.show_upload_error_list &&
            <CardBody style={{ marginTop: 6 }}>
              <div>
                <h6 style={{ color: '#ec3e51' }}> {this.state.uploaderrorListMessage}</h6>
                <Table
                  responsive
                  className="table--bordered"
                  style={{ marginBottom: 75 }}
                >
                  <thead>
                    <tr>
                      <th>SkU7 code</th>
                      <th>MRP</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.upload_error_list.map((item, key) =>
                      <tr key={key}>
                        <td>{item.sku7_code}</td>
                        <td>{item.mrp} </td>
                        <td>{item.reason} </td>
                      </tr>

                    )}

                  </tbody>
                </Table>
              </div>




            </CardBody>
          }


          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <span>
                  {" "}
                  <span style={{ fontWeight: "bold" }}> GRN Number: </span>{" "}
                  <span> {this.state.grnValues} / </span>{" "}
                  <span style={{ fontWeight: "bold" }}> GRN Line Number: </span>{" "}
                  <span> {this.state.grnLineValue} </span>
                </span>

                <ButtonToolbar className="form__button-toolbar">
                  {this.state.showAssignButton && (
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={this.toggle}
                      type="submit"
                    >
                      Assign
                    </Button>
                  )}
                  {this.state.showPrintButton && (
                    <Button color="primary" className="btn-sm" type="submit">
                      Print
                    </Button>
                  )}
                </ButtonToolbar>
              </div>

              <div className="table_val">
                <MDBTable autoWidth striped>
                  <MDBTableHead columns={GRNData.columns} />
                  <MDBTableHead>
                    {this.state.loadingGRNData && (
                      <div
                        style={{
                          width: "2300%",
                          textAlign: "center",
                          paddingTop: 22,
                        }}
                      >
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px", fontSize: 18 }}
                        />
                      </div>
                    )}
                  </MDBTableHead>
                  <MDBTableBody scrollX rows={GRNData.rows} />
                </MDBTable>
              </div>
            </CardBody>
          )}


        </Card>

        <Modal
          isOpen={modalAssignUser}
          toggle={this.toggleAssignUser}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th>Bin Count</th>
                  <th style={{ textAlign: 'left' }}>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div className="form__form-group">
                          <div className="form__form-group-field">
                            <Select
                              isMulti
                              style={{ minWidth: 100 }}
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeValStock(selectedOptions, item.id)
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                              className="react-select"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.toggleAssignUser}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modalAssignUserCycleCount}
          toggle={this.toggleAssignUserCycleCount}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                {" "}
                Estimated Scan Count :{" "}
                <span style={{ color: "red" }}>
                  {" "}
                  {this.state.totalScanCount}{" "}
                </span>{" "}
              </span>
            </div>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th> Bin Count </th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData1).length > 0 &&
                  _.map(uniqueZoneData1, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div
                          className="form__form-group"
                          style={{ width: "100%" }}
                        >
                          <div
                            style={{ width: "100%" }}
                            className="form__form-group-field"
                          >
                            <MySelect
                              style={{ width: "100%" }}
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeVal(
                                  selectedOptions,
                                  item.zoneId,
                                  item.items
                                )
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.toggleAssignUserCycleCount}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData1}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <form className="form form--inline">
              <div
                className="form__form-group col-xl-10"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{
                    display: "inline",
                    paddingTop: 6,
                    paddingBottom: 6,
                    fontWeight: "bold",
                  }}
                >
                  Select User
                </span>

                <div
                  className="form__form-group-field col-xl-7"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select User"
                    onChange={this.change1}
                    options={[
                      { value: "user1", label: "WMS User" },
                      { value: "test", label: "Test User" },
                    ]}
                  />
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>
            </form>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={successModal} toggle={this.successToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Sucessfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successToggle1}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{ marginRight: 8 }}
              className="modal_cancel"
              onClick={this.messagetoggle}
            // onClick={this.cancelMessageModal}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={cycleCountCancelModal} toggle={this.onCancelCycleModal}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancelCycleModal}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{ marginRight: 8 }}
              className="modal_cancel"
              onClick={this.onCancelCycleModal}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModalCycle} toggle={this.messageToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.messageToggleCycle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{ marginRight: 8 }}
              className="modal_cancel"
              onClick={this.messageToggleCycle}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModalCycle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailed} toggle={this.failedToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.failedToggleCancel}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalCancel} toggle={this.cancelToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.cancelToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.cancelReason} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.cancelToggle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailedCycle} toggle={this.failedToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.failedToggleCancelCycle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalReport}
          toggle={this.toggleReports}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Download Reports
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%" }}>
                <tr>
                  <td>SKU Level and PKM level Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadSKU}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Physical Excess Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadExcessStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Complete Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadCompleteStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" style={{ textAlign: "center" }}>
                    <ButtonToolbar
                      className="modal__footer"
                      style={{ paddingTop: 12, paddingBottom: 20 }}
                    >
                      <button
                        className="modal_cancel"
                        onClick={this.closeReportModal}
                      >
                        Cancel
                      </button>
                    </ButtonToolbar>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
